<template>
  <b-modal
    id="cargarAvlsPorTextoModal"
    ref="modal"
    title="Cargar AVL'S por texto"
    size="lg"
    hide-footer
    lazy
    centered
    @show="onShown"
  >
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <label for="id_avls" class="label"
                >Ingrese los IDs de los AVLs separados por coma</label
              >
              <input
                class="form-control bg-white text-center"
                style="cursor: text"
                type="text"
                id="id_avls"
                name="id_avls"
                v-model="id_avls"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-between">
              <button
                type="button"
                @click="$bvModal.hide('cargarAvlsPorTextoModal')"
                class="btn btn-danger"
              >
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary">Confirmar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "CargarAvlsPorTextoModal",
  props: {
    availableAvls: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    id_avls: "",
  }),

  methods: {
    onShown() {
      this.id_avls = "";
      this.$nextTick(() => {
        if (this.$refs.inputAvls) {
          this.$refs.inputAvls.focus();
        }
      });
    },
    cancelar() {
      this.$bvModal.hide("cargarAvlsPorTextoModal");
      this.id_avls = "";
    },
    async submit() {
      if (!this.id_avls.trim()) {
        this.$msgBoxOk("Por favor ingrese al menos un ID de AVL");
        return;
      }

      // Validar y limpiar los IDs
      const idsLimpios = this.id_avls
        .split(",")
        .map((id) => {
          console.log(id);
          return id.trim();
        })
        .filter((id) => {
          console.log(id);
          return id !== "";
        });
      console.log("limpios", idsLimpios);

      // Validar que todos sean números
      const idsInvalidos = idsLimpios.filter((id) => {
        console.log(id);
        !/^\d+$/.test(id);
      });

      if (idsInvalidos.length > 0) {
        await this.$msgBoxOk(
          `Los siguientes valores no son IDs válidos: ${idsInvalidos.join(", ")}`,
        );
        return;
      }

      if (idsLimpios.length === 0) {
        await this.$msgBoxOk("No se encontraron IDs válidos");
        return;
      }

      // Filtrar solo los AVL's que existen en la lista disponible
      const avlsValidos = idsLimpios.filter((id) =>
        this.availableAvls.includes(id),
      );
      const avlsInvalidos = idsLimpios.filter(
        (id) => !this.availableAvls.includes(id),
      );

      if (avlsValidos.length === 0) {
        await this.$msgBoxOk(
          "Ninguno de los AVL's ingresados existe en la lista actual",
        );
        return;
      }

      // Mostrar confirmación si hay AVL's inválidos
      if (avlsInvalidos.length > 0) {
        const confirmacion = await this.$bvModal.msgBoxConfirm(
          `Se procesarán ${avlsValidos.length} AVL's válidos.` +
            `Los siguientes ${avlsInvalidos.length} AVL's no existen y serán ignorados:\n` +
            `${avlsInvalidos.join(", ")}\n\n` +
            `¿Desea continuar?`,
          { centered: true, title: "Confirmar" },
        );

        if (!confirmacion) {
          return;
        }
      }

      // Emitir solo los AVL's válidos al componente padre
      this.$emit("update", avlsValidos.join(", "));

      // Cerrar el modal
      this.$bvModal.hide("cargarAvlsPorTextoModal");

      // Limpiar el campo
      this.id_avls = "";
      // await this.$msgBoxOk(`Se agregaron ${avlsValidos.length} AVL's válidos.`);
    },
  },
};
</script>
